import { computed, defineComponent } from 'vue';
import { StatusHelper } from '@getaccept/lib-shared-new/src/helpers/status.helper';
import { DocumentStatus } from '@getaccept/lib-shared-new/src/enums/document-status';
import { useI18n } from 'vue-i18n';
export default defineComponent({
    name: 'ContractLinkHeader',
    props: {
        status: { type: String, default: null },
        expired: { type: Boolean },
        blockWidthClass: { type: String, default: null },
    },
    setup(props) {
        const { t } = useI18n();
        const showStatus = computed(() => props.status === DocumentStatus.Signed ||
            props.status === DocumentStatus.Recalled ||
            props.status === DocumentStatus.Expired ||
            props.expired);
        const statusBadgeContent = computed(() => ({
            text: getStatusText.value,
            statusType: getStatusType.value,
            border: StatusHelper.getDocumentHasBadgeBorder(props.status),
        }));
        const getStatusText = computed(() => props.status === DocumentStatus.Recalled || props.expired
            ? t('document-status-expired')
            : StatusHelper.getDocumentStatusTranslation(props.status));
        const getStatusType = computed(() => props.expired
            ? StatusHelper.getDocumentStatusType(DocumentStatus.Expired)
            : StatusHelper.getDocumentStatusType(props.status));
        return {
            showStatus,
            statusBadgeContent,
            getStatusText,
            getStatusType,
        };
    },
});
